import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import Footer from "../components/footer"

export default function Template({ data }) {
  const { title, date, body, meta_description, featured_image, author } =
    data.butterPost
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`MyRadar | ${title}`}</title>
        <meta property="og:type" content="article" />
        <meta property="og:title" content={title} />
        <meta property="og:image" content={featured_image} />
        <meta property="og:description" content={meta_description} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={meta_description} />
        <meta property="twitter:image" content={featured_image} />
      </Helmet>
      <Layout>
        <div className="post">
          <div className="modules">
            <div className="row">
              <div className="column">
                <img src={featured_image} alt="" />
              </div>
            </div>
          </div>
          <div className="content">
            <div className="inside">
              <h3 class="title">
                MyRadar
                <br />
                News
                <br />—
              </h3>
              <div className="sep"></div>
              <div className="row">
                <div class="column">
                  <h1>{title}</h1>
                  <h5>
                    by{" "}
                    <a href={`/authors/${author.slug}`}>
                      {author.first_name} {author.last_name}
                    </a>{" "}
                    {author.title.length > 0 ? ` | ${author.title}` : ""}
                  </h5>
                  <h4>{date}</h4>
                  <div dangerouslySetInnerHTML={{ __html: body }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <Footer />
    </React.Fragment>
  )
}

export const pageQuery = graphql`
  query ($slug: String!) {
    butterPost(slug: { eq: $slug }) {
      title
      date
      body
      featured_image
      author {
        first_name
        last_name
        twitter_handle
        title
        slug
      }
    }
  }
`
